import { compareStrings } from '@/filters/helpers';
import { endOfDay } from 'date-fns';

export default {
  folders: (state) => {
    return state.folders;
  },
  foldersMain: (state, getters) => {
    if (getters.lessonsFilter?.itemTypes?.length) return [];
    if (getters.lessonsFilter?.archived) return getters.filteredFolders;
    return getters.filteredFolders.filter((i) => !i.folder_id);
  },
  filteredFolders: (state, getters) => {
    // filter folders by lessons filters and text search
    return filterFolders(
      state.folders,
      getters.lessonsSearch,
      getters.lessonsFilter
    );
  },
  folderFolders: (state, getters) => {
    return (folderId) => {
      return getters.filteredFolders.filter((i) => i.folder_id === folderId);
    };
  },
  foldersLoaded: (state) => {
    return state.foldersLoaded;
  },
  loadingSingleFolder(state) {
    return state.loadingSingleFolder;
  },
  currentFolder(state) {
    return state.currentFolder;
  },
  singleFolder(state) {
    return (folderId) => {
      return state.folders.find((i) => i.id === folderId) || null;
    };
  },
};

const filterFolders = (folders, search, filter) => {
  const { archived, owners, createdAfter, createdBefore, recentlyEdited } =
    filter || {};
  const sevenDaysAgoMs = Date.now() - 86400 * 7 * 1000;

  folders = folders.filter(({ deleted_at }) =>
    archived ? deleted_at : !deleted_at
  );

  if (owners?.length) {
    const ownerIds = owners.map(String);
    folders = folders.filter(({ user_id }) =>
      ownerIds.includes(String(user_id))
    );
  }

  if (createdAfter) {
    folders = folders.filter(
      ({ created_at }) => created_at * 1000 >= new Date(createdAfter).getTime()
    );
  }

  if (createdBefore) {
    const beforeMs = endOfDay(new Date(createdBefore)).getTime();
    folders = folders.filter(({ created_at }) => created_at * 1000 <= beforeMs);
  }

  if (recentlyEdited) {
    folders = folders.filter(
      ({ updated_at }) => updated_at * 1000 > sevenDaysAgoMs
    );
  }

  if (search) {
    folders = folders.filter(({ name }) => compareStrings(name, search));
  }
  return folders;
};
